import { filterBookingEmployees } from 'scenes/management/bookings/_functions/bookings'
import _ from 'lodash'
import i18n from 'utils/i18n'
import { Keyboard, Pressable } from 'react-native'
import Input from "theme/Input";
import React, { useEffect, useRef, useState } from 'react'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Icon from 'components/atoms/Icon'

const EmployeeSearch = ({ onChange, employees }) => {
	
	const inputRef = useRef( null )
	const searched = useRef( false )
	
	const [ searchValue, setSearchValue ] = useState( '' )
	const [ employeesFiltered, setEmployeesFiltered ] = useState( [] )
	
	const onFilterSearch = () => {
		setEmployeesFiltered( filterBookingEmployees( employees, searchValue ) )
	}
	
	const onChangeSearch = ( query ) => {
		searched.current = true;
		
		query = (query !== null) ? query.toLowerCase() : '';
		
		setSearchValue( query )
	}
	
	const onClearSearch = () => {
		inputRef.current.clear()
		onChangeSearch( null )
	}
	
	useEffect( onFilterSearch, [ searchValue ] )
	
	useEffect( () => {
		// Skip when not typed yet
		if( searched.current === false ) {
			return;
		}
		
		if( _.isFunction( onChange ) ) {
			if( !_.isEmpty( searchValue ) ) {
				onChange( employeesFiltered )
			} else {
				onChange( null )
			}
		}
	}, [ employeesFiltered ] )
	
	useEffect( () => {
		setEmployeesFiltered( filterBookingEmployees( employees ) )
	}, [] )
	
	return (
		<Input
			ref={ inputRef }
			autoCorrect={ false }
			spellCheck={ false }
			placeholder={ i18n.t('management:pages.bookings.view.search_employee') }
			onChangeText={ _.debounce( onChangeSearch, 250 ) }
			accessoryRight={(
				<Pressable
					onPress={ onClearSearch }>
					
					<Icon icon={ IconSystemConstants.CLOSE } />
				</Pressable>
			)}
			returnKeyType={ "done" }
			onSubmitEditing={ Keyboard.dismiss }
		/>
	)
}

export default EmployeeSearch
